<template>
  <div class="bg-white border-b border-gray-200 px-6 py-4 sticky top-0 z-10 mt-4">
    <div class="tw-flex items-center justify-between">
      <div class="tw-flex space-x-4 flex-col">
        <h1 class="text-3xl text-black">{{ title }}</h1>
        <p class="text-gray-500 !mr-0 !ml-0">{{ subtitle }}</p>
      </div>
      <div class="tw-flex flex-row">
        <!-- Built-in Action Button (if provided via props) -->
        <DsButton
          v-if="actionButton && !hasActionSlot"
          @click="handleActionClick"
          :variant="actionButton.variant || 'rounded'"
          :label="actionButton.label"
          :icon="actionButton.icon"
        >
          {{ actionButton.label }}
        </DsButton>

        <!-- Custom Action Button Slot (takes precedence) -->
        <slot name="action-button"></slot>

        <!-- Built-in Dropdown Actions (if provided via props) -->
        <DropdownActionsButton
          v-if="dropdownActions && dropdownActions.length > 0 && !hasDropdownSlot && shouldShowDropdown"
          :actions="dropdownActions"
        >
          <template v-slot:button>
            <div class="bg-white rounded hover:bg-primary-100 hover:cursor-pointer">
              <DsButton
                icon="ellipsis-v"
                icon-fill-color="black"
                variant="rounded-minimal"
              />
            </div>
          </template>
        </DropdownActionsButton>

        <!-- Custom Dropdown Action Button Slot (takes precedence) -->
        <slot name="dropdown-action-button"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import Container from '../Container/Container.vue'
  import UserMixin from '@/util/UserMixin'
  import ConfigMixin from '@/util/ConfigMixin'
  import DropdownActionsButton from '@/Domain/Shared/Components/DropdownActionsButton.vue'

  export default {
    name: 'SimplifiedHeroNew',
    mixins: [UserMixin, ConfigMixin],
    data () {
      return {}
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      subtitle: {
        type: String,
        default: '',
      },
      // Built-in action button
      actionButton: {
        type: Object,
        default: null,
        // Expected format: { label: 'Add Post', icon: 'plus', variant: 'rounded', onClick: function }
      },
      // Built-in dropdown actions
      dropdownActions: {
        type: Array,
        default: () => [],
        // Expected format: [{ label: 'Action', onClick: function, variant?: 'danger' }, ...]
      },
    },
    components: {
      DropdownActionsButton,
      Container,
    },
    computed: {
      hasActionSlot () {
        return !!this.$slots['action-button']
      },
      hasDropdownSlot () {
        return !!this.$slots['dropdown-action-button']
      },
      shouldShowDropdown () {
        return this.isMember
      }
    },
    methods: {
      handleActionClick () {
        if (this.actionButton && typeof this.actionButton.onClick === 'function') {
          this.actionButton.onClick()
        }
        this.$emit('action-click', this.actionButton)
      }
    },
  }
</script>
